import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

// ✅ GET ALL BLOGS (/blog-data/)
export const getBlogs = createAsyncThunk(
  "blogs/getBlogs",
  async (params = {}, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();

      if (params.page) queryParams.append("page", params.page);
      if (params.search) queryParams.append("search", params.search);

      const queryString = queryParams.toString();
      const url = queryString ? `/blog-data/?${queryString}` : `/blog-data/`;

      const res = await axiosInstance.get(url);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message ||
          err.response?.data ||
          "Failed to fetch blog data",
      );
    }
  },
);

// ✅ GET BLOG BY ID (/blog-data/${id}/)
export const getBlogById = createAsyncThunk(
  "blogs/getBlogById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get(`/blog-data/${id}/`);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message ||
          err.response?.data ||
          "Failed to fetch blog details",
      );
    }
  },
);

// ✅ CREATE BLOG (/blog-data/) [POST]
export const createBlog = createAsyncThunk(
  "blogs/createBlog",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(`/blog-data/`, payload, {
        headers:
          payload instanceof FormData
            ? { "Content-Type": "multipart/form-data" }
            : { "Content-Type": "application/json" },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message ||
          err.response?.data?.errors ||
          err.response?.data ||
          "Failed to create blog",
      );
    }
  },
);

// ✅ UPDATE BLOG (/blog-data/${id}/) [PATCH]
export const updateBlog = createAsyncThunk(
  "blogs/updateBlog",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.patch(`/blog-data/${id}/`, data, {
        headers:
          data instanceof FormData
            ? { "Content-Type": "multipart/form-data" }
            : { "Content-Type": "application/json" },
      });
      return res.data;
    } catch (err) {
      console.error("Update Blog Error:", err.response?.data);
      return rejectWithValue(
        err.response?.data?.message ||
          err.response?.data?.errors ||
          err.response?.data ||
          "Failed to update blog",
      );
    }
  },
);

// ✅ DELETE BLOG (/blog-data/${id}/) [DELETE]
export const deleteBlog = createAsyncThunk(
  "blogs/deleteBlog",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/blog-data/${id}/`);
      return id;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message ||
          err.response?.data ||
          "Failed to delete blog",
      );
    }
  },
);
